import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';
import ChartEmptyState from './ChartEmptyState';

const DEFAULT_COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#6366f1', '#ef4444'];

export default function DashboardBarChart({
  data = [],
  height = 240,
  xKey = 'bin',
  valueKey = 'count',
  emptyState = null,
  colors = DEFAULT_COLORS,
}) {
  const chartData = data?.length ? data : [];
  const hasData = chartData.some((row) => (row[valueKey] || 0) > 0);

  if (!hasData) {
    return emptyState || <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" vertical={false} />
        <XAxis
          dataKey={xKey}
          tick={{ fontSize: 11, fill: 'var(--color-text-secondary)' }}
          tickLine={false}
          axisLine={{ stroke: 'var(--color-border)' }}
        />
        <YAxis
          tick={{ fontSize: 11, fill: 'var(--color-text-secondary)' }}
          tickLine={false}
          axisLine={false}
          allowDecimals={false}
        />
        <Tooltip
          contentStyle={{
            background: 'var(--color-bg-secondary)',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius-lg)',
          }}
        />
        <Bar dataKey={valueKey} radius={[4, 4, 0, 0]}>
          {chartData.map((entry, index) => (
            <Cell key={entry[xKey]} fill={colors[index % colors.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
